import React from "react"
import { Collapse, Typography, Flex } from "antd"
import ValidationWrapper from "../ValidationWrapper/ValidationWrapper"

// styles
import "./ValidationOrganizer.scss"

const { Text } = Typography

interface FieldValidation {
  field_key: string
  type: "NOTE" | "ERROR" | "WARNING"
  text: string
}

interface ValidationCategory {
  label: string
  labelIcon: string
  labelClassName: string
  count: number
  messages: FieldValidation[]
}

interface ValidationMap {
  ERROR: ValidationCategory
  WARNING: ValidationCategory
  NOTE: ValidationCategory
}

interface ValidationItem {
  key: string
  label: React.ReactNode
  children: React.ReactNode
}

// @ts-ignore
export default function ValidationOrganizer({ validations, type }) {
  const validationMap: ValidationMap = React.useMemo(() => {
    const map: ValidationMap = {
      ERROR: {
        label: "Error(s)",
        labelIcon: "fas fa-do-not-enter",
        labelClassName: "--error-validation",
        count: 0,
        messages: [],
      },
      WARNING: {
        label: "Warning(s)",
        labelIcon: "fas fa-exclamation-triangle",
        labelClassName: "--warning-validation",
        count: 0,
        messages: [],
      },
      NOTE: {
        label: "Note(s)",
        labelIcon: "fas fa-info-circle",
        labelClassName: "--note-validation",
        count: 0,
        messages: [],
      },
    }

    validations.forEach((item: FieldValidation) => {
      const typeSet = new Set(["ERROR", "WARNING", "NOTE"])
      const typeToUpper = item?.type?.toUpperCase()
      const type = typeSet.has(typeToUpper) ? typeToUpper : "NOTE"

      //@ts-ignore
      map[type].messages.push(item)
      //@ts-ignore
      map[type].count++
    })
    return map
  }, [validations])

  const items: ValidationItem[] = React.useMemo(() => {
    if (validationMap) {
      return (Object.keys(validationMap) as Array<keyof ValidationMap>)
        .filter((key) => validationMap[key].count > 0)
        .map((key) => ({
          key,
          label: (
            <Flex
              gap={4}
              align="center"
            >
              <i
                className={`${validationMap[key].labelIcon} ${validationMap[key].labelClassName}`}
                style={{ marginTop: 1 }}
              />
              <Text
                style={{ fontWeight: 600 }}
              >{`${validationMap[key].label} (${validationMap[key].messages.length})`}</Text>
            </Flex>
          ),
          children: (
            <ValidationWrapper
              messages={validationMap[key].messages}
              type={type}
            />
          ),
        }))
    }

    return []
  }, [validationMap])

  return (
    <Collapse
      bordered={false}
      expandIcon={({ isActive }) => <i className={`fa-light fa-angle-${isActive ? "down" : "right"}`} />}
      style={{ background: "transparent" }}
      items={items}
    />
  )
}
